
const digest = '8a05bdc718c9428c860f4c00a4b0ee2841ceeea6ddbdbcf4e6f246004f54a4c8';
const classes = {"success":"_success_103er_1","danger":"_danger_103er_6"};
const css = `._success_103er_1 {
  color: #1d7a3a;
  font-weight: 600;
}

._danger_103er_6 {
  color: #b42318;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  